import { WithErrorAndLoading } from "@/components/with-error-and-loading";
import { BenchListingCard } from "./components/listing-card";
import { NotFoundIcon } from "@/components/notfound";
import { useNavigate } from "react-router-dom";
import { Wrench } from "lucide-react";
import { useAllBenchStates } from "./use-all-bench-states";
import { ConnectButton } from "@/components/connect-button";
import BenchHero from "./components/bench-hero";
import { capitalizeFirst } from "@/lib/utils";
import { BenchStateSmall } from "@myth-finance/bench-sdk";
import { BenchLogoSmall } from "./components/bench-logo-small";

export function Bench() {
  const navigate = useNavigate();
  const { isPending: loading, error, data: benches } = useAllBenchStates();

  return (
    <div className="container flex flex-col gap-4 mx-auto">
      <BenchHero />

      <div className="flex flex-col md:flex-row justify-center flex-nowrap md:flex-wrap items-center gap-4">
        <WithErrorAndLoading loading={loading} error={error?.message}>
          {Object.entries(benches ?? {})
            .filter(([_, benches]) => benches.length)
            .map(([stateName, benches]: [string, BenchStateSmall[]]) => (
              <>
                <h2 className="w-full text-center mt-6 flex justify-center items-center gap-4">
                  <BenchLogoSmall className="text-muted-foreground stroke-muted-foreground"/>
                  {capitalizeFirst(stateName)} 
                  <BenchLogoSmall className="text-muted-foreground stroke-muted-foreground"/>
                </h2>
                {benches.map((bench, i) => (
                  <BenchListingCard key={`a${i}`} {...bench} />
                ))}
              </>
            ))}
          {!benches?.closed?.length &&
          !benches?.open?.length &&
          !benches?.upcoming?.length ? (
            <div className="flex  mt-8 flex-col items-center">
              <NotFoundIcon className="mb-8 text-muted-foreground" />
              <div className="text-lg">No benches found.</div>
            </div>
          ) : null}
        </WithErrorAndLoading>
      </div>
    {false && !loading && !error /* TODO open */ ? (
        <div className="mt-8 flex flex-col md:flex-row justify-center flex-nowrap md:flex-wrap items-center gap-4">
          <ConnectButton
            connectLabel="Connect to create Bench"
            onClick={() => navigate("/bench/create")}
            variant={"outline"}
          >
            <Wrench className="mr-2" />
            Create Bench
          </ConnectButton>
        </div>
      ) : null}
    </div>
  );
}
